import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallQuestionMarkIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M9 9a3 3 0 1 1 4 2.829 1.5 1.5 0 0 0 -1 1.415v1.006"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path d="M12 18a0.375 0.375 0 0 1 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path d="M12 18a0.375 0.375 0 0 0 0 -0.75" stroke={stroke} strokeWidth={1.5} />
      <path
        d="M12 23.25c6.213 0 11.25 -5.037 11.25 -11.25S18.213 0.75 12 0.75 0.75 5.787 0.75 12 5.787 23.25 12 23.25Z"
        stroke={stroke}
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
